document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;

  function openDrawer() {
    body.classList.add('filter-drawer-open');
  }

  function closeDrawer() {
    body.classList.remove('filter-drawer-open');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-filter-drawer-open]')) {
      event.preventDefault();
      openDrawer();
    }

    if (
      event.target.closest('[data-filter-drawer-close]') ||
      event.target.closest('[data-filter-drawer-overlay]')
    ) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  function applyPreorderFilter(isActive) {
    document.querySelectorAll('product-card[data-is-preorder]').forEach(function (card) {
      const isPreorder = card.dataset.isPreorder === 'true';
      const isNotify = card.dataset.isNotify === 'true';
      const gridItem = card.closest('.product-grid__item');
      const target = gridItem || card;

      if (isActive) {
        if (isNotify || isPreorder) {
          target.style.display = '';
        } else {
          target.style.display = 'none';
        }
      } else {
        target.style.display = '';
      }
    });
  }


  document.addEventListener('change', function (event) {
    const availableCheckbox = event.target.matches('input[name="filter.v.availability"][value="1"]');
    const specialOrderToggle = event.target.matches('[data-special-order-toggle]');

    if (!availableCheckbox && !specialOrderToggle) return;

  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-special-order-toggle]')) return;
    if (event.target.disabled) return;

    applyPreorderFilter(event.target.checked);
  });

  document.addEventListener('custom-filter-drawer:refresh', function () {
    const toggle = document.querySelector('[data-special-order-toggle]');

    if (toggle && !toggle.disabled) {
      applyPreorderFilter(toggle.checked);
    }
  });

  const toggle = document.querySelector('[data-special-order-toggle]');

  if (toggle && !toggle.disabled) {
    applyPreorderFilter(toggle.checked);
  }
});

(function () {
  const PRODUCT_SELECTOR = '#ResultsList .product-grid > .product-grid__item:not(.collection-promo-tile)';
  const GRID_SELECTOR = '#ResultsList .product-grid';
  const DRAWER_SELECTOR = '.custom-filter-drawer';
  const LOAD_MORE_WRAP_SELECTOR = '.product-grid__load-more-wrap';
  const BUTTON_ATTR = 'data-load-more-button';
  const TRIGGER_AFTER = 20;

  let nextUrl = null;
  let isFetching = false;
  let infiniteScrollActive = false;
  let sentinel = null;
  let observer = null;

  async function fetchAndAppend(url) {
    const response = await fetch(url, {
      credentials: 'same-origin'
    });

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const grid = document.querySelector(GRID_SELECTOR);

    if (!grid) return null;

    const newItems = doc.querySelectorAll(PRODUCT_SELECTOR);
    const fragment = document.createDocumentFragment();

    newItems.forEach(function (item) {
      fragment.appendChild(item);
    });

    if (sentinel && sentinel.parentNode === grid) {
      grid.insertBefore(fragment, sentinel);
    } else {
      grid.appendChild(fragment);
    }

    document.dispatchEvent(new CustomEvent('custom-filter-drawer:refresh'));

    const newButton = doc.querySelector('[' + BUTTON_ATTR + ']');

    return newButton ? newButton.getAttribute('href') : null;
  }

  function refreshLayout() {
    const drawer = document.querySelector(DRAWER_SELECTOR);

    requestAnimationFrame(function () {
      if (drawer) {
        drawer.classList.remove('is-floating');
        void drawer.offsetHeight;
      }

      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
      document.dispatchEvent(new CustomEvent('custom-filter-drawer:refresh'));
    });
  }

  function attachSentinel() {
    const grid = document.querySelector(GRID_SELECTOR);

    if (!grid || sentinel) return;

    sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.className = 'custom-filter-drawer-sentinel';
    sentinel.style.cssText = 'height:1px;width:100%;pointer-events:none;';
    grid.appendChild(sentinel);
  }

  function startInfiniteScroll() {
    if (infiniteScrollActive || !sentinel) return;

    infiniteScrollActive = true;

    observer = new IntersectionObserver(async function ([entry]) {
      if (!entry.isIntersecting || isFetching || !nextUrl) return;

      isFetching = true;

      try {
        nextUrl = await fetchAndAppend(nextUrl);
        refreshLayout();

        if (!nextUrl) {
          observer.disconnect();

          if (sentinel) {
            sentinel.remove();
            sentinel = null;
          }
        }
      } catch (err) {
        console.error('Infinite scroll fetch failed:', err);
      } finally {
        isFetching = false;
      }
    }, {
      rootMargin: '0px 0px 300px 0px'
    });

    observer.observe(sentinel);
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[' + BUTTON_ATTR + ']');

    if (!button) return;

    event.preventDefault();

    const grid = document.querySelector(GRID_SELECTOR);

    if (!grid) return;

    nextUrl = button.getAttribute('href');

    if (!nextUrl) return;

    const wrap = button.closest(LOAD_MORE_WRAP_SELECTOR);
    const originalText = button.textContent;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading...';

    attachSentinel();

    try {
      while (nextUrl) {
        const currentCount = grid.querySelectorAll(PRODUCT_SELECTOR).length;

        if (currentCount >= TRIGGER_AFTER) break;

        nextUrl = await fetchAndAppend(nextUrl);
      }

      if (wrap) wrap.remove();

      refreshLayout();

      if (nextUrl) {
        startInfiniteScroll();
      }
    } catch (err) {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.textContent = originalText;

      if (nextUrl) {
        window.location.href = nextUrl;
      }
    }
  });
})();

// Filter sticky behavior
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('.custom-filter-drawer');

  if (!drawer) return;

  let currentState = '';
  let ticking = false;
  let beforeLoadMoreReleaseTimer = null;

  const STOP_AREA_OFFSET = 100;
  const BEFORE_LOAD_MORE_RELEASE_DELAY = 200;

  function getFirstVisibleElement(selector) {
    return Array.from(document.querySelectorAll(selector)).find(function (el) {
      const rect = el.getBoundingClientRect();

      return rect.width > 0 && rect.height > 0;
    });
  }

  function getStopper() {
    return getFirstVisibleElement(
      '.stopper, .custom-filter-drawer-stopper, .product-grid__load-more-wrap, [data-load-more-button]'
    );
  }

  function getFooter() {
    return getFirstVisibleElement(
      '#footer-group, footer, .shopify-section-group-footer-group'
    );
  }

  function getDocumentPercent() {
    const scrollTop = window.scrollY || window.pageYOffset;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;

    return docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;
  }

  function elementReachedViewport(el, offset) {
    if (!el) return false;

    const rect = el.getBoundingClientRect();

    return rect.top <= window.innerHeight + offset && rect.bottom >= 0;
  }

  function isNearStopArea() {
    const stopper = getStopper();
    const footer = getFooter();

    return (
      elementReachedViewport(stopper, STOP_AREA_OFFSET) ||
      elementReachedViewport(footer, STOP_AREA_OFFSET)
    );
  }

  function clearBeforeLoadMoreReleaseTimer() {
    window.clearTimeout(beforeLoadMoreReleaseTimer);
    beforeLoadMoreReleaseTimer = null;
  }

  function setDrawerState(nextState) {
    if (currentState === nextState) return;

    currentState = nextState;

    // Removed the toggle for 'is-top-area'
    drawer.classList.toggle('is-sticky', nextState === 'sticky');
    drawer.classList.toggle('is-before-load-more', nextState === 'before-load-more');
  }

  function releaseBeforeLoadMoreToSticky() {
    clearBeforeLoadMoreReleaseTimer();

    beforeLoadMoreReleaseTimer = window.setTimeout(function () {
      if (isNearStopArea()) return;

      setDrawerState('sticky');
    }, BEFORE_LOAD_MORE_RELEASE_DELAY);
  }

  function updateFilterDrawerState() {
    ticking = false;

    if (isNearStopArea()) {
      clearBeforeLoadMoreReleaseTimer();
      setDrawerState('before-load-more');
      return;
    }

    if (currentState === 'before-load-more') {
      releaseBeforeLoadMoreToSticky();
      return;
    }

    clearBeforeLoadMoreReleaseTimer();
    setDrawerState('sticky');
  }

  function requestUpdateFilterDrawerState() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateFilterDrawerState);
  }

  updateFilterDrawerState();

  window.addEventListener('scroll', requestUpdateFilterDrawerState, { passive: true });
  window.addEventListener('resize', requestUpdateFilterDrawerState);

  document.addEventListener('custom-filter-drawer:refresh', function () {
    setTimeout(updateFilterDrawerState, 50);
    setTimeout(updateFilterDrawerState, 250);
    setTimeout(updateFilterDrawerState, 600);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(updateFilterDrawerState, 50);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[data-custom-filter-form]');

  if (!form) return;

  const submitButton = form.querySelector('[data-filter-submit]');
  const submitCount = form.querySelector('[data-filter-submit-count]');

  let countTimer = null;
  let activeRequest = null;
  let requestSequence = 0;

  function sanitizePriceInput(input) {
    let value = input.value || '';

    value = value.replace(',', '.');
    value = value.replace(/[^0-9.]/g, '');

    const parts = value.split('.');

    if (parts.length > 2) {
      value = parts.shift() + '.' + parts.join('');
    }

    input.value = value;
  }

  function buildFilterUrl() {
    const url = new URL(form.action, window.location.origin);
    const formData = new FormData(form);

    formData.forEach(function (value, key) {
      value = String(value || '').trim();

      if (!value) return;

      url.searchParams.append(key, value);
    });

    return url;
  }

  function makeOptionKey(paramName, value) {
    return String(paramName || '') + '\u0000' + String(value || '');
  }

  function updateGroupActiveCounts() {
    form.querySelectorAll('[data-filter-group]').forEach(function (group) {
      const countElement = group.querySelector('[data-filter-group-count]');

      if (!countElement) return;

      let activeCount = 0;

      group
        .querySelectorAll(
          'input[type="checkbox"]:checked, input[type="radio"]:checked'
        )
        .forEach(function (input) {
          if (!input.disabled) {
            activeCount += 1;
          }
        });

      group.querySelectorAll('[data-price-input]').forEach(function (input) {
        if (String(input.value || '').trim() !== '') {
          activeCount = 1;
        }
      });

      countElement.textContent = '(' + activeCount + ')';
      countElement.hidden = activeCount === 0;
    });
  }

  function getReturnedResultCount(doc) {
    const marker = doc.querySelector('[data-filter-results-count]');

    if (marker) {
      const value = Number(String(marker.textContent || '').trim());

      if (Number.isFinite(value)) {
        return value;
      }
    }

    const resultsList = doc.querySelector('results-list[data-results-count]');

    if (resultsList) {
      const value = Number(resultsList.dataset.resultsCount);

      if (Number.isFinite(value)) {
        return value;
      }
    }

    const returnedSubmitCount = doc.querySelector('[data-filter-submit-count]');

    if (returnedSubmitCount) {
      const match = String(returnedSubmitCount.textContent || '').match(/\d+/);

      if (match) {
        return Number(match[0]);
      }
    }

    return null;
  }

  function synchronizeOptionCounts(doc) {
    const returnedOptions = new Map();

    doc.querySelectorAll('[data-filter-option]').forEach(function (option) {
      const key = makeOptionKey(
        option.dataset.filterParam,
        option.dataset.filterValue
      );

      const countElement = option.querySelector('[data-filter-option-count]');
      const count = Number(String(countElement?.textContent || '0').trim());

      returnedOptions.set(key, {
        count: Number.isFinite(count) ? count : 0
      });
    });

    form.querySelectorAll('[data-filter-option]').forEach(function (option) {
      const key = makeOptionKey(
        option.dataset.filterParam,
        option.dataset.filterValue
      );

      const returned = returnedOptions.get(key);
      const input = option.querySelector('[data-filter-input]');
      const countElement = option.querySelector('[data-filter-option-count]');

      if (!input || !countElement) return;

      const count = returned ? returned.count : 0;
      const shouldDisable = count === 0 && input.checked === false;

      countElement.textContent = String(count);
      input.disabled = shouldDisable;
      option.classList.toggle('is-disabled', shouldDisable);
    });
  }

  function setLoading(isLoading) {
    if (!submitButton) return;

    if (isLoading) {
      submitButton.setAttribute('aria-busy', 'true');
    } else {
      submitButton.removeAttribute('aria-busy');
    }
  }

  async function fetchFilteredState() {
    const sequence = ++requestSequence;
    const url = buildFilterUrl();

    if (activeRequest) {
      activeRequest.abort();
    }

    activeRequest = new AbortController();
    setLoading(true);

    try {
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: activeRequest.signal
      });

      if (!response.ok) {
        throw new Error('Filter request failed with status ' + response.status);
      }

      const html = await response.text();

      if (sequence !== requestSequence) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const resultCount = getReturnedResultCount(doc);

      synchronizeOptionCounts(doc);

      if (submitCount && resultCount !== null) {
        submitCount.textContent = '(' + resultCount + ')';
      }

      document.dispatchEvent(
        new CustomEvent('custom-filter-drawer:counts-updated', {
          detail: {
            count: resultCount,
            url: url.toString()
          }
        })
      );
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('Filter count update failed:', error);
      }
    } finally {
      if (sequence === requestSequence) {
        setLoading(false);
        activeRequest = null;
      }
    }
  }

  function scheduleFilteredStateUpdate(delay) {
    window.clearTimeout(countTimer);

    countTimer = window.setTimeout(function () {
      fetchFilteredState();
    }, typeof delay === 'number' ? delay : 220);
  }

  form.querySelectorAll('[data-price-input]').forEach(function (input) {
    input.addEventListener('keydown', function (event) {
      const blockedKeys = ['e', 'E', '+', '-'];

      if (blockedKeys.includes(event.key)) {
        event.preventDefault();
      }
    });

    input.addEventListener('input', function () {
      sanitizePriceInput(input);
      updateGroupActiveCounts();
      scheduleFilteredStateUpdate(300);
    });

    input.addEventListener('paste', function () {
      window.setTimeout(function () {
        sanitizePriceInput(input);
        updateGroupActiveCounts();
        scheduleFilteredStateUpdate(0);
      }, 0);
    });
  });

  form.addEventListener('change', function () {
    updateGroupActiveCounts();
    scheduleFilteredStateUpdate(120);
  });

  form.addEventListener('submit', function () {
    form.querySelectorAll('[data-price-input]').forEach(function (input) {
      sanitizePriceInput(input);
    });
  });

  updateGroupActiveCounts();
});